import { useMediaQuery } from "@material-ui/core"
import PropTypes from "prop-types"
import React from "react"

import Box from "~/components/Common/Box"
import useStyles from "./styles"

const CourseLessonContentContainer = ({ leftComponent, rightComponent }) => {
  const classes = useStyles()
  const previewBreakpoint = useMediaQuery("(max-width:1280px)")

  return (
    <Box
      className={classes.container}
      style={{ display: previewBreakpoint ? "block" : "flex" }}
    >
      <Box
        className={classes.leftContainer}
        style={{ width: previewBreakpoint ? "100%" : "40%" }}
      >
        {leftComponent}
      </Box>
      <Box
        className={classes.rightContainer}
        style={{ width: previewBreakpoint ? "100%" : "60%" }}
      >
        {rightComponent}
      </Box>
    </Box>
  )
}

CourseLessonContentContainer.propTypes = {
  leftComponent: PropTypes.node,
  rightComponent: PropTypes.node,
}

export default CourseLessonContentContainer
